(function () {
  'use strict';

  function round5(n) { return Math.round((Number(n) || 0) / 5) * 5; }
  function money(n) { return '£' + Math.max(0, round5(n)); }
  function range(n) {
    n = Number(n) || 0;
    if (n < 1) return 'Not ready';
    var low = round5(n * 0.92);
    var high = round5(n * 1.08);
    return '£' + Math.max(0, low) + '–£' + Math.max(0, high);
  }
  function label(item) {
    return [item && item.manufacturer, item && item.model, item && item.variant]
      .filter(Boolean)
      .join(' ')
      .replace(/\s+/g, ' ')
      .trim();
  }
  function norm(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function toArray(value) { return Array.prototype.slice.call(value || []); }
  function escapeRegExp(value) { return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function init(root) {
    if (!root || root.dataset.dlbEstimatorInitialized === 'true') return;
    root.dataset.dlbEstimatorInitialized = 'true';

    var dataUrl = root.dataset.priceUrl;
    var quoteEndpoint = root.dataset.quoteEndpoint || 'https://sell.dlbuilds.co.uk/api/submit';
    var turnstileSiteKey = String(root.dataset.turnstileSiteKey || '').trim();
    var quoteIdStorageKey = 'dlbSellToUsQuoteId:' + (window.location && window.location.pathname ? window.location.pathname : 'default');
    var storedQuoteId = '';
    try { storedQuoteId = window.sessionStorage ? sessionStorage.getItem(quoteIdStorageKey) : ''; } catch (e) { storedQuoteId = ''; }
    var quoteId = root.dataset.quoteId || storedQuoteId || ('DLB-WEB-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2, 7).toUpperCase());
    root.dataset.quoteId = quoteId;
    try { if (window.sessionStorage) sessionStorage.setItem(quoteIdStorageKey, quoteId); } catch (e) {}

    var isSubmittingQuote = false;
    var items = [];
    var selected = {};
    var uncertain = {};
    var knowledgeModes = {};
    var currentType = null;
    var currentStage = 'choose';
    var pendingType = null;
    var manualRequested = false;
    var priceListAvailable = true;
    var lastHelpFocus = null;
    var previousBodyOverflow = '';
    var cleanupCallbacks = [];

    var stages = toArray(root.querySelectorAll('[data-stage]'));
    var fieldSets = toArray(root.querySelectorAll('[data-fields]'));
    var progressItems = toArray(root.querySelectorAll('[data-progress]'));
    var typeButtons = toArray(root.querySelectorAll('[data-type]'));
    var knowledgeStep = root.querySelector('[data-knowledge-step]');
    var detailsStep = root.querySelector('[data-details-step]');
    var detailsToolbar = root.querySelector('[data-details-toolbar]');
    var knowledgeSummary = root.querySelector('[data-knowledge-summary]');
    var buildTitle = root.querySelector('[data-build-title]');
    var buildNote = root.querySelector('[data-build-note]');
    var floating = root.querySelector('[data-floating-summary]');
    var summary = root.querySelector('[data-summary]');
    var estimateSummary = root.querySelector('[data-estimate-summary]');
    var contactSummary = root.querySelector('[data-contact-summary]');
    var unlockNote = root.querySelector('[data-unlock-note]');
    var inlineEstimate = root.querySelector('[data-inline-estimate]');
    var continueButton = root.querySelector('[data-continue]');
    var manualButton = root.querySelector('[data-manual]');
    var cashRanges = toArray(root.querySelectorAll('[data-cash-range]'));
    var creditRanges = toArray(root.querySelectorAll('[data-credit-range]'));
    var accuracyElements = toArray(root.querySelectorAll('[data-accuracy]'));
    var accuracyMessage = root.querySelector('[data-accuracy-message]');
    var estimateImprove = root.querySelector('[data-estimate-improve]');
    var estimateAuto = root.querySelector('[data-estimate-auto]');
    var estimateManual = root.querySelector('[data-estimate-manual]');
    var messageField = root.querySelector('[data-message-field]');
    var requestType = root.querySelector('[data-request-type-field]');
    var itemField = root.querySelector('[data-item-field]');
    var estimateSummaryField = root.querySelector('[data-estimate-summary-field]');
    var cashField = root.querySelector('[data-cash-field]');
    var creditField = root.querySelector('[data-credit-field]');
    var quoteIdField = root.querySelector('[data-quote-id-field]');
    var submittedAtField = root.querySelector('[data-submitted-at-field]');
    var formSourceField = root.querySelector('[data-form-source-field]');
    var postSubmitProducts = root.querySelector('[data-post-submit-products]');
    var postSubmitProductGrid = root.querySelector('[data-post-submit-product-grid]');
    var backupWrap = root.querySelector('[data-backup-wrap]');
    var showBackupButton = root.querySelector('[data-show-backup-contact]');
    var errorText = root.querySelector('[data-error-text]');
    var priceStatus = root.querySelector('[data-price-status]');
    var typeConfirm = root.querySelector('[data-type-confirm]');
    var currentTypeName = root.querySelector('[data-current-type-name]');
    var summaryMobileValue = root.querySelector('[data-summary-mobile-value]');
    var help = root.querySelector('[data-spec-help]');
    var helpPanel = help ? help.querySelector('.dlb-help__panel') : null;
    var helpTitle = help ? help.querySelector('[data-help-title]') : null;
    var helpCopy = help ? help.querySelector('[data-help-copy]') : null;
    var helpExamples = help ? help.querySelector('[data-help-examples]') : null;
    var helpGeneral = help ? help.querySelector('[data-help-general]') : null;
    var helpSpecific = help ? help.querySelector('[data-help-specific]') : null;
    var helpSteps = help ? help.querySelector('[data-help-steps]') : null;
    var helpCards = help ? help.querySelector('[data-help-cards]') : null;
    var helpHomeParent = help ? help.parentNode : null;
    var helpHomeNextSibling = help ? help.nextSibling : null;
    var offerOptionInputs = toArray(root.querySelectorAll('[data-offer-option]'));
    var offerChoice = root.querySelector('[data-offer-choice]');
    var offerChoiceError = root.querySelector('[data-offer-choice-error]');
    var partExchangeField = root.querySelector('[data-part-exchange-field]');
    var partExchangeUrl = root.querySelector('[data-part-exchange-url]');
    var partExchangeError = root.querySelector('[data-part-exchange-error]');
    var turnstileContainer = root.querySelector('[data-turnstile-container]');
    var turnstileError = root.querySelector('[data-turnstile-error]');
    var turnstileWidgetId = null;
    var turnstileToken = '';
    var productCollectionHandle = root.dataset.productCollection || 'all';

    var typeMeta = {
      gaming: {
        title: 'Gaming PC',
        heading: 'Let’s take a look at your gaming PC',
        note: 'Do not worry if you are unsure. Enter what you know and we will help with the rest.',
        requiredParts: ['gaming-cpu', 'gaming-gpu'],
        requiredSelects: ['gaming-ram'],
        pcDeduction: 0.92
      },
      office: {
        title: 'Office PC',
        heading: 'Let’s take a look at your everyday PC',
        note: 'The processor, memory and main storage are the most useful details. You can ask for help or skip anything you cannot find.',
        requiredParts: ['office-cpu'],
        requiredSelects: ['office-ram', 'office-storage'],
        pcDeduction: 0.90
      },
      gpu: {
        title: 'Graphics Card',
        heading: 'Tell us about the graphics card',
        note: 'Find the closest exact model for an automatic estimate, or enter a partial name for manual review.',
        requiredParts: ['gpu-gpu'],
        requiredSelects: [],
        pcDeduction: 1
      },
      components: {
        title: 'Components',
        heading: 'Which components are you selling?',
        note: 'Add only the parts you have. Leave everything else blank.',
        requiredParts: [],
        requiredSelects: [],
        pcDeduction: 1
      },
      laptop: {
        title: 'Laptop',
        heading: 'Tell us about the laptop',
        note: 'Laptop values vary by exact model, screen, battery and condition, so we review these manually.',
        manual: true
      },
      other: {
        title: 'Something else',
        heading: 'Tell us what you are selling',
        note: 'Enter any identifying information you can find. Partial details are fine.',
        manual: true
      }
    };

    var knowledgeLabels = {
      knows: 'Route: I know the specifications',
      some: 'Route: I know some specifications',
      help: 'Route: Help me find the specifications'
    };

    var helpTopics = {
      general: {
        title: 'Help me find my specifications',
        copy: 'Use either Windows method below. Your progress stays safely in the form while this guide is open.',
        examples: ['Processor', 'Graphics card', 'Memory', 'Storage'],
        general: true
      },
      cpu: {
        title: 'Find the processor (CPU)',
        copy: 'The processor name is shown clearly in Windows. Copy as much of the name as you can see.',
        examples: ['AMD Ryzen 5 5600X', 'Intel Core i5-10400', 'Intel Core i7-12700'],
        steps: ['Right-click the Windows Start button and open Task Manager.', 'Choose Performance, then select CPU.', 'Copy the name shown near the top-right into the processor field.'],
        cards: [
          { title: 'What to copy', text: 'Include the brand, series and model number where possible.' },
          { title: 'Partial names are fine', text: 'Something like “Ryzen 5” or “Intel i7” can still be reviewed manually.' }
        ]
      },
      gpu: {
        title: 'Find the graphics card (GPU)',
        copy: 'A gaming PC may show more than one graphics option. Look for the NVIDIA, AMD Radeon or Intel Arc model.',
        examples: ['NVIDIA GeForce RTX 3070', 'AMD Radeon RX 6700 XT', 'Intel Arc A750'],
        steps: ['Open Task Manager and choose Performance.', 'Select GPU 0, GPU 1 or each GPU shown in the left-hand list.', 'Copy the NVIDIA, AMD Radeon or Intel Arc model into the graphics card field.'],
        cards: [
          { title: 'More than one GPU?', text: 'Integrated Intel or AMD graphics can appear alongside a separate gaming graphics card.' },
          { title: 'Not sure which one?', text: 'Enter every GPU name you can see in the notes, or choose “I am not sure”.' }
        ]
      },
      ram: {
        title: 'Find the memory (RAM)',
        copy: 'Windows normally shows the total memory as 8GB, 16GB, 32GB or 64GB.',
        examples: ['8GB', '16GB', '32GB', '64GB'],
        steps: ['Open Task Manager and choose Performance.', 'Select Memory.', 'Use the total shown near the top-right and choose the closest RAM option in the form.'],
        cards: [
          { title: 'Capacity matters most', text: 'The total amount, such as 16GB or 32GB, is the most useful detail.' },
          { title: 'DDR type unknown?', text: 'Choose “I am not sure” and we can confirm whether it is DDR4 or DDR5 later.' }
        ]
      },
      storage: {
        title: 'SSD, HDD or NVMe?',
        copy: 'Choose the closest drive type and capacity. Windows can usually show whether the drive is an SSD or HDD.',
        examples: ['500GB NVMe SSD', '1TB SATA SSD', '1TB HDD', '2TB HDD'],
        steps: ['Open Task Manager and choose Performance.', 'Select Disk 0, Disk 1 or each disk shown.', 'Look beneath the disk name for SSD or HDD, then choose the closest capacity in the form.'],
        cards: [
          { title: 'NVMe SSD', text: 'A fast type of SSD. The model name may include “NVMe” or “PCIe”.' },
          { title: 'SATA SSD', text: 'A standard solid-state drive. Windows may simply label it “SSD”.' },
          { title: 'HDD', text: 'A traditional hard drive. Windows normally labels it “HDD”.' }
        ]
      }
    };


    function on(target, eventName, handler, options) {
      if (!target || !target.addEventListener) return;
      target.addEventListener(eventName, handler, options || false);
      cleanupCallbacks.push(function () { target.removeEventListener(eventName, handler, options || false); });
    }

    function activeFieldSet() {
      return currentType ? root.querySelector('[data-fields="' + currentType + '"]') : null;
    }

    function smoothBehaviour() { return prefersReducedMotion() ? 'auto' : 'smooth'; }

    function focusStage(name) {
      var stage = root.querySelector('[data-stage="' + name + '"]');
      if (!stage) return;
      var heading = stage.querySelector('h3[tabindex="-1"], [data-build-title][tabindex="-1"]');
      if (heading) {
        try { heading.focus({ preventScroll: true }); } catch (e) { heading.focus(); }
      }
    }

    function showStage(name, options) {
      options = options || {};
      currentStage = name;
      root.dataset.currentStage = name;
      closeAllCombos();
      stages.forEach(function (stage) {
        var active = stage.dataset.stage === name;
        stage.classList.toggle('is-active', active);
        stage.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      var order = ['choose', 'build', 'estimate', 'contact'];
      var activeIndex = order.indexOf(name);
      progressItems.forEach(function (item) {
        var itemIndex = order.indexOf(item.dataset.progress);
        var isCurrent = itemIndex === activeIndex;
        var isComplete = itemIndex < activeIndex;
        item.classList.toggle('is-active', isCurrent);
        item.classList.toggle('is-complete', isComplete);
        if (isCurrent) item.setAttribute('aria-current', 'step');
        else item.removeAttribute('aria-current');
      });

      var showSummary = name === 'build' && !!currentType;
      root.classList.toggle('has-summary', showSummary);
      if (floating) floating.classList.toggle('is-active', showSummary);
      if (name === 'estimate') renderEstimateStage();
      if (name === 'contact') renderContactSummary();
      if (!options.noFocus) focusStage(name);
      if (options.scroll) {
        try { root.scrollIntoView({ behavior: smoothBehaviour(), block: 'start' }); } catch (e) { root.scrollIntoView(true); }
      }
    }

    function categoryItems(category) {
      return items.filter(function (item) { return norm(item.category) === norm(category); });
    }

    function sortCapacityThenType(a, b) {
      var typeOrder = { 'nvme ssd': 1, 'sata ssd': 2, 'hdd': 3 };
      var ta = typeOrder[norm(a.manufacturer)] || 9;
      var tb = typeOrder[norm(b.manufacturer)] || 9;
      if (ta !== tb) return ta - tb;
      return label(a).localeCompare(label(b), undefined, { numeric: true });
    }

    function populateRamSelects() {
      var ramItems = categoryItems('RAM').sort(function (a, b) {
        return label(a).localeCompare(label(b), undefined, { numeric: true });
      });
      toArray(root.querySelectorAll('[data-ram-select]')).forEach(function (select) {
        var previous = select.value;
        var first = select.options[0] ? select.options[0].text : 'Select RAM';
        select.innerHTML = '';
        var placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = first;
        select.appendChild(placeholder);
        ramItems.forEach(function (item) {
          var option = document.createElement('option');
          option.dataset.value = item.offerValue || item.suggestedOffer || 0;
          option.value = label(item);
          option.textContent = label(item);
          select.appendChild(option);
        });
        if (previous && toArray(select.options).some(function (option) { return option.value === previous; })) select.value = previous;
      });
    }

    function populateStorageSelects() {
      var storageItems = categoryItems('Storage').sort(sortCapacityThenType);
      toArray(root.querySelectorAll('[data-storage-select]')).forEach(function (select) {
        var previous = select.value;
        var mode = select.dataset.storageSelect || 'all';
        var first = select.options[0] ? select.options[0].text : (mode === 'extra' ? 'No extra storage / not sure' : 'Select storage');
        select.innerHTML = '';
        var placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = first;
        placeholder.dataset.value = '0';
        select.appendChild(placeholder);

        storageItems.filter(function (item) {
          var type = norm(item.manufacturer);
          if (mode === 'main') return type === 'nvme ssd' || type === 'sata ssd';
          if (mode === 'extra') return type === 'hdd' || type === 'sata ssd' || type === 'nvme ssd';
          return true;
        }).forEach(function (item) {
          var option = document.createElement('option');
          option.dataset.value = item.offerValue || item.suggestedOffer || 0;
          option.value = label(item);
          option.textContent = label(item);
          select.appendChild(option);
        });
        if (previous && toArray(select.options).some(function (option) { return option.value === previous; })) select.value = previous;
      });
    }

    function setVisualSelectState(group) {
      if (!group) return;
      var container = group.closest('.dlb-question-card, .dlb-field');
      var select = container ? container.querySelector('[data-condition], [data-faults]') : null;
      if (!select) return;
      toArray(group.querySelectorAll('[data-visual-value]')).forEach(function (button) {
        var optionIndex = button.dataset.optionIndex;
        var selectedByIndex = optionIndex !== undefined && optionIndex !== '' && Number(optionIndex) === select.selectedIndex;
        var selectedByValue = (optionIndex === undefined || optionIndex === '') && String(button.dataset.visualValue) === String(select.value);
        var active = selectedByIndex || selectedByValue;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function setupVisualSelect(group) {
      var container = group.closest('.dlb-question-card, .dlb-field');
      var select = container ? container.querySelector('[data-condition], [data-faults]') : null;
      if (!select) return;
      toArray(group.querySelectorAll('[data-visual-value]')).forEach(function (button) {
        on(button, 'click', function () {
          var optionIndex = button.dataset.optionIndex;
          if (optionIndex !== undefined && optionIndex !== '') select.selectedIndex = Number(optionIndex);
          else {
            var wanted = String(button.dataset.visualValue);
            var foundIndex = toArray(select.options).findIndex(function (option) { return String(option.value) === wanted; });
            if (foundIndex >= 0) select.selectedIndex = foundIndex;
          }
          setVisualSelectState(group);
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      setVisualSelectState(group);
    }

    function typeHasData(type) {
      if (!type) return false;
      var fieldSet = root.querySelector('[data-fields="' + type + '"]');
      if (!fieldSet) return false;
      var hasSelected = Object.keys(selected).some(function (key) { return key.indexOf(type + '-') === 0 && !!selected[key]; });
      var hasUncertain = Object.keys(uncertain).some(function (key) { return key.indexOf(type + '-') === 0 && !!uncertain[key]; });
      var hasComboText = toArray(fieldSet.querySelectorAll('[data-combo-input]')).some(function (input) { return input.value.trim() !== ''; });
      var hasSelect = toArray(fieldSet.querySelectorAll('[data-standard-select]')).some(function (select) { return select.selectedIndex > 0; });
      var hasManual = toArray(fieldSet.querySelectorAll('[data-manual-input]')).some(function (input) { return input.value.trim() !== ''; });
      return hasSelected || hasUncertain || hasComboText || hasSelect || hasManual;
    }

    function clearType(type) {
      if (!type) return;
      var fieldSet = root.querySelector('[data-fields="' + type + '"]');
      Object.keys(selected).forEach(function (key) { if (key.indexOf(type + '-') === 0) delete selected[key]; });
      Object.keys(uncertain).forEach(function (key) { if (key.indexOf(type + '-') === 0) delete uncertain[key]; });
      delete knowledgeModes[type];
      if (fieldSet) {
        toArray(fieldSet.querySelectorAll('[data-combo-input], [data-manual-input]')).forEach(function (input) {
          input.value = '';
          delete input.dataset.value;
        });
        toArray(fieldSet.querySelectorAll('[data-standard-select]')).forEach(function (select) { select.selectedIndex = 0; });
        toArray(fieldSet.querySelectorAll('[data-condition], [data-faults]')).forEach(function (select) {
          var defaultValue = select.dataset.defaultValue;
          if (defaultValue !== undefined) {
            var index = toArray(select.options).findIndex(function (option) { return String(option.value) === String(defaultValue); });
            select.selectedIndex = index >= 0 ? index : 0;
          }
        });
        toArray(fieldSet.querySelectorAll('[data-question-card]')).forEach(function (card) { delete card.dataset.everAvailable; });
        toArray(fieldSet.querySelectorAll('[data-recognition]')).forEach(function (recognition) {
          recognition.classList.remove('is-loaded', 'is-manual');
        });
        toArray(fieldSet.querySelectorAll('[data-visual-select]')).forEach(setVisualSelectState);
      }
    }

    function updateTypeButtons() {
      typeButtons.forEach(function (button) {
        var active = button.dataset.type === currentType;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function showTypeConfirmation(type) {
      pendingType = type;
      if (currentTypeName) currentTypeName.textContent = typeMeta[currentType] ? typeMeta[currentType].title : 'your current item';
      if (typeConfirm) {
        typeConfirm.hidden = false;
        try { typeConfirm.scrollIntoView({ behavior: smoothBehaviour(), block: 'nearest' }); } catch (e) {}
      }
    }

    function applyType(type) {
      currentType = type;
      manualRequested = false;
      pendingType = null;
      if (typeConfirm) typeConfirm.hidden = true;
      var meta = typeMeta[type] || typeMeta.other;
      if (buildTitle) buildTitle.textContent = meta.heading || meta.title;
      if (buildNote) buildNote.textContent = meta.note;
      fieldSets.forEach(function (fieldSet) { fieldSet.classList.toggle('is-active', fieldSet.dataset.fields === type); });
      updateTypeButtons();
      updateKnowledgeView();
      updateEstimate();
      showStage('build', { scroll: true });
    }

    function setType(type) {
      if (!typeMeta[type]) type = 'other';
      if (currentType && currentType !== type && typeHasData(currentType)) {
        showTypeConfirmation(type);
        return;
      }
      if (currentType && currentType !== type) clearType(currentType);
      applyType(type);
    }

    function updateKnowledgeView() {
      if (!currentType) return;
      var needsKnowledge = currentType === 'gaming' || currentType === 'office';
      var mode = knowledgeModes[currentType];
      if (knowledgeStep) knowledgeStep.hidden = !needsKnowledge || !!mode;
      if (detailsStep) detailsStep.hidden = needsKnowledge && !mode;
      if (detailsToolbar) detailsToolbar.hidden = !needsKnowledge || !mode;
      if (knowledgeSummary) knowledgeSummary.textContent = mode ? knowledgeLabels[mode] : '';
      toArray(root.querySelectorAll('[data-knowledge]')).forEach(function (button) {
        var active = button.dataset.knowledge === mode;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      refreshQuestionFlow();
    }

    function setKnowledge(mode) {
      if (!currentType || (currentType !== 'gaming' && currentType !== 'office')) return;
      knowledgeModes[currentType] = mode;
      updateKnowledgeView();
      updateEstimate();
      if (detailsStep) {
        try { detailsStep.scrollIntoView({ behavior: smoothBehaviour(), block: 'start' }); } catch (e) {}
      }
      if (mode === 'help') openHelp('general');
    }

    function partValue(key) {
      return selected[key] ? Number(selected[key].offerValue || selected[key].suggestedOffer || 0) : 0;
    }

    function standardValue(name) {
      var element = root.querySelector('[data-standard-select="' + name + '"]');
      return element && element.selectedIndex > 0 ? Number(element.options[element.selectedIndex].dataset.value || 0) : 0;
    }

    function standardSelected(name) {
      var element = root.querySelector('[data-standard-select="' + name + '"]');
      return !!(element && element.selectedIndex > 0);
    }

    function conditionMult() {
      var element = root.querySelector('[data-condition="' + currentType + '"]');
      return element ? Number(element.value || 1) : 1;
    }

    function faultsMult() {
      var element = root.querySelector('[data-faults="' + currentType + '"]');
      return element ? Number(element.value || 1) : 1;
    }

    function componentCount() {
      var count = 0;
      Object.keys(selected).forEach(function (key) {
        if (selected[key] && key.indexOf(currentType + '-') === 0) count++;
      });
      toArray(root.querySelectorAll('[data-standard-select]')).forEach(function (select) {
        var fieldSet = select.closest('[data-fields]');
        if (fieldSet && fieldSet.classList.contains('is-active') && select.selectedIndex > 0) count++;
      });
      return count;
    }

    function estimateUnlocked() {
      if (!currentType || typeMeta[currentType].manual) return false;
      if (currentType === 'components') return componentCount() >= 2;
      var meta = typeMeta[currentType];
      var partsOk = meta.requiredParts.every(function (key) { return !!selected[key]; });
      var selectsOk = meta.requiredSelects.every(standardSelected);
      return partsOk && selectsOk;
    }

    /* Valuation formulas deliberately remain identical to the previous implementation. */
    function calc() {
      if (!currentType) return 0;
      var total = 0;
      if (currentType === 'gaming') total = partValue('gaming-cpu') + partValue('gaming-gpu') + standardValue('gaming-ram') + standardValue('gaming-storage') + standardValue('gaming-extra-storage');
      if (currentType === 'office') total = partValue('office-cpu') + standardValue('office-ram') + standardValue('office-storage') + standardValue('office-extra-storage');
      if (currentType === 'gpu') total = partValue('gpu-gpu');
      if (currentType === 'components') total = partValue('components-cpu') + partValue('components-gpu') + partValue('components-motherboard') + standardValue('components-ram') + standardValue('components-storage');
      total *= (typeMeta[currentType].pcDeduction || 1);
      total *= conditionMult() * faultsMult();
      return Math.max(0, total);
    }

    function selectedSummary() {
      var rows = [];
      function add(key, title) { if (selected[key]) rows.push([title, label(selected[key])]); }
      if (currentType === 'gaming') { add('gaming-gpu', 'GPU'); add('gaming-cpu', 'CPU'); }
      if (currentType === 'office') add('office-cpu', 'CPU');
      if (currentType === 'gpu') add('gpu-gpu', 'GPU');
      if (currentType === 'components') {
        add('components-cpu', 'CPU');
        add('components-gpu', 'GPU');
        add('components-motherboard', 'Motherboard');
      }
      toArray(root.querySelectorAll('[data-standard-select]')).forEach(function (select) {
        var fieldSet = select.closest('[data-fields]');
        if (fieldSet && fieldSet.classList.contains('is-active') && select.selectedIndex > 0) {
          rows.push([select.dataset.label || select.dataset.standardSelect, select.options[select.selectedIndex].text]);
        }
      });
      return rows;
    }

    function keyDisplayName(key) {
      var names = {
        'gaming-gpu': 'GPU', 'gaming-cpu': 'CPU', 'gaming-ram': 'RAM', 'gaming-storage': 'Main storage', 'gaming-extra-storage': 'Extra storage',
        'office-cpu': 'CPU', 'office-ram': 'RAM', 'office-storage': 'Main storage', 'office-extra-storage': 'Extra storage',
        'gpu-gpu': 'GPU', 'components-cpu': 'CPU', 'components-gpu': 'GPU', 'components-motherboard': 'Motherboard', 'components-ram': 'RAM', 'components-storage': 'Storage'
      };
      return names[key] || key;
    }

    function partialSummary() {
      var rows = [];
      var fieldSet = activeFieldSet();
      if (!fieldSet) return rows;
      toArray(fieldSet.querySelectorAll('[data-combo-input]')).forEach(function (input) {
        var key = input.dataset.comboInput;
        var value = input.value.trim();
        if (value && !selected[key]) rows.push([keyDisplayName(key), value, 'Entered for manual review']);
        else if (!value && uncertain[key]) rows.push([keyDisplayName(key), uncertain[key], 'To confirm manually']);
      });
      toArray(fieldSet.querySelectorAll('[data-standard-select]')).forEach(function (select) {
        var key = select.dataset.standardSelect;
        if (select.selectedIndex === 0 && uncertain[key]) rows.push([keyDisplayName(key), uncertain[key], 'To confirm manually']);
      });
      return rows;
    }

    function manualSummary() {
      var rows = [];
      var fieldSet = activeFieldSet();
      if (!fieldSet) return rows;
      var names = { make: 'Make', model: 'Model', age: 'Approximate age', printed: 'Printed information', description: 'Description' };
      toArray(fieldSet.querySelectorAll('[data-manual-input]')).forEach(function (input) {
        var value = input.value.trim();
        if (value) rows.push([names[input.dataset.manualInput] || input.dataset.manualInput, value]);
      });
      return rows;
    }

    function currentSelectText(selector) {
      var element = root.querySelector(selector);
      return element && element.selectedIndex >= 0 ? element.options[element.selectedIndex].text : '';
    }

    function conditionRows() {
      var rows = [];
      if (!currentType) return rows;
      var condition = currentSelectText('[data-condition="' + currentType + '"]');
      var faults = currentSelectText('[data-faults="' + currentType + '"]');
      if (condition) rows.push(['Condition', condition]);
      if (faults) rows.push(['Working status', faults]);
      return rows;
    }

    function displaySummaryRows() {
      return selectedSummary().concat(partialSummary()).concat(manualSummary()).concat(conditionRows());
    }

    function hasUncertaintyForCurrent() {
      return Object.keys(uncertain).some(function (key) { return currentType && key.indexOf(currentType + '-') === 0 && !!uncertain[key]; }) || partialSummary().length > 0;
    }

    function hasMeaningfulDetails() {
      return componentCount() > 0 || partialSummary().length > 0 || manualSummary().length > 0 || hasUncertaintyForCurrent();
    }

    function canProceedDetails() {
      if (!currentType) return false;
      if (typeMeta[currentType].manual) return manualSummary().length > 0;
      return estimateUnlocked() || hasMeaningfulDetails();
    }

    function missingText() {
      if (!currentType) return 'Choose what you are selling to begin.';
      if (typeMeta[currentType].manual) {
        return manualSummary().length ? 'Your information is ready for manual review.' : 'Add a make, model or short description so we know what to value.';
      }
      if (estimateUnlocked() && !manualRequested) return 'Your automatic estimate is ready.';
      if (hasMeaningfulDetails()) return 'That is still helpful. Continue and we will confirm any missing or unmatched details manually.';
      if (currentType === 'gaming') return 'Add the graphics card, processor and RAM, or use “I am not sure” to continue manually.';
      if (currentType === 'office') return 'Add the processor, RAM and main storage, or use “I am not sure” to continue manually.';
      if (currentType === 'gpu') return 'Select the graphics card, or enter a partial name for manual review.';
      if (currentType === 'components') return 'Add at least one component. Two recognised components unlock an automatic estimate.';
      return 'Enter whatever you know to continue.';
    }

    function accuracyState() {
      if (!currentType || !hasMeaningfulDetails()) {
        return { label: 'Needs details', message: 'Enter the main specifications to improve accuracy.', improve: '' };
      }
      if (typeMeta[currentType].manual || manualRequested || !estimateUnlocked()) {
        return { label: 'Rough estimate', message: 'Based on partial or unmatched information and requiring manual review.', improve: 'Add an exact component model where possible to make the valuation quicker to confirm.' };
      }
      if (currentType === 'gaming') {
        if (standardSelected('gaming-storage') && !hasUncertaintyForCurrent()) return { label: 'Highly accurate estimate', message: 'The main value-driving components have been identified.', improve: 'We will still confirm condition and completeness during testing.' };
        return { label: 'Good estimate', message: 'The processor, graphics card and RAM have been identified.', improve: 'Select the main storage to improve accuracy.' };
      }
      if (currentType === 'office') return { label: 'Highly accurate estimate', message: 'The processor, memory and main storage have been identified.', improve: 'We will confirm the final value after inspection and testing.' };
      if (currentType === 'gpu') return { label: 'Highly accurate estimate', message: 'The exact graphics card model has been identified.', improve: 'The final value still depends on testing, condition and completeness.' };
      if (currentType === 'components') {
        var count = componentCount();
        if (count >= 4) return { label: 'Highly accurate estimate', message: 'Most of the selected components have been identified.', improve: 'Check that every component you are selling is included.' };
        if (count >= 3) return { label: 'Good estimate', message: 'Several components have been identified.', improve: 'Add any remaining component to improve accuracy.' };
        return { label: 'Rough estimate', message: 'Based on two identified components.', improve: 'Add more components to make the estimate more complete.' };
      }
      return { label: 'Good estimate', message: 'The main details have been identified.', improve: '' };
    }

    function questionComplete(card) {
      if (!card) return false;
      if (card.hasAttribute('data-optional-question')) return true;
      var combo = card.querySelector('[data-combo-input]');
      if (combo) return !!selected[combo.dataset.comboInput] || !!uncertain[combo.dataset.comboInput];
      var standard = card.querySelector('[data-standard-select]');
      if (standard) return standard.selectedIndex > 0 || !!uncertain[standard.dataset.standardSelect];
      if (card.querySelector('[data-condition], [data-faults]')) return true;
      return false;
    }

    function refreshQuestionFlow() {
      var fieldSet = activeFieldSet();
      if (!fieldSet) return;
      var cards = toArray(fieldSet.querySelectorAll('[data-question-card]'));
      if (!cards.length) return;
      var mode = knowledgeModes[currentType];
      var showAll = currentType !== 'gaming' && currentType !== 'office' || mode === 'knows';
      var blocked = false;
      var currentAssigned = false;
      cards.forEach(function (card) {
        var complete = questionComplete(card);
        var available;
        if (showAll) available = true;
        else if (card.dataset.everAvailable === 'true') available = true;
        else if (!blocked) {
          available = true;
          card.dataset.everAvailable = 'true';
        } else available = false;

        card.classList.toggle('is-available', available);
        card.classList.toggle('is-complete', complete);
        card.classList.remove('is-current');
        if (available && !complete && !currentAssigned) {
          card.classList.add('is-current');
          currentAssigned = true;
        }
        if (!showAll && available && !complete) blocked = true;
      });
    }

    function renderRows(container, rows, emptyText) {
      if (!container) return;
      container.innerHTML = '';
      if (!rows.length) {
        var empty = document.createElement('div');
        empty.className = 'dlb-summary-empty';
        empty.textContent = emptyText || 'Add details to build your summary.';
        container.appendChild(empty);
        return;
      }
      rows.forEach(function (row) {
        var div = document.createElement('div');
        div.className = 'dlb-summary-row';
        var name = document.createElement('span');
        name.textContent = row[0];
        var value = document.createElement('strong');
        value.textContent = row[1];
        if (row[2]) {
          var note = document.createElement('em');
          note.textContent = row[2];
          value.appendChild(note);
        }
        div.appendChild(name);
        div.appendChild(value);
        container.appendChild(div);
      });
    }

    function renderSummary() {
      renderRows(summary, displaySummaryRows(), 'Add your main specifications to reveal an estimate.');
      renderRows(estimateSummary, displaySummaryRows(), 'No details have been entered yet.');
    }

    function estimateIsAutomatic() {
      return !!(currentType && !typeMeta[currentType].manual && estimateUnlocked() && !manualRequested);
    }

    function setPriceText() {
      var automatic = estimateIsAutomatic();
      var total = calc();
      var cash = automatic ? range(total) : (hasMeaningfulDetails() ? 'Manual review' : 'Not ready');
      var credit = automatic ? range(total * 1.05) : (hasMeaningfulDetails() ? 'Manual review' : 'Not ready');
      cashRanges.forEach(function (element) { element.textContent = cash; });
      creditRanges.forEach(function (element) { element.textContent = credit; });
      if (summaryMobileValue) summaryMobileValue.textContent = automatic ? cash + ' cash' : (hasMeaningfulDetails() ? 'Manual valuation' : 'Estimate not ready yet');
    }

    function buildGeneratedDetailsText() {
      var lines = [];
      partialSummary().forEach(function (row) { lines.push(row[0] + ': ' + row[1] + (row[2] ? ' (' + row[2] + ')' : '')); });
      manualSummary().forEach(function (row) { lines.push(row[0] + ': ' + row[1]); });
      return lines.join('\n');
    }

    function buildMessage(force) {
      var typeName = currentType ? typeMeta[currentType].title : 'Sell to us';
      var total = calc();
      var automatic = estimateIsAutomatic();
      var summaryLines = ['Sell to us estimate request', '', 'Item type: ' + typeName];
      if (automatic) {
        summaryLines.push('Estimated cash offer: ' + range(total));
        summaryLines.push('Estimated part exchange: ' + range(total * 1.05));
      } else {
        summaryLines.push('Estimate shown: Manual valuation needed');
      }
      summaryLines.push('');
      selectedSummary().forEach(function (row) { summaryLines.push(row[0] + ': ' + row[1]); });
      partialSummary().forEach(function (row) { summaryLines.push(row[0] + ' (customer entered): ' + row[1]); });
      manualSummary().forEach(function (row) { summaryLines.push(row[0] + ': ' + row[1]); });
      var preferenceLines = offerPreferenceLines();
      if (preferenceLines.length) {
        summaryLines.push('');
        preferenceLines.forEach(function (line) { summaryLines.push(line); });
      }
      var condition = root.querySelector('[data-condition="' + currentType + '"]');
      if (condition) summaryLines.push('Condition: ' + condition.options[condition.selectedIndex].text);
      var faults = root.querySelector('[data-faults="' + currentType + '"]');
      if (faults) summaryLines.push('Faults/issues: ' + faults.options[faults.selectedIndex].text);

      if (estimateSummaryField) estimateSummaryField.value = summaryLines.join('\n');
      if (cashField) cashField.value = automatic ? range(total) : 'Manual valuation needed';
      if (creditField) creditField.value = automatic ? range(total * 1.05) : 'Manual valuation needed';
      if (requestType) requestType.value = currentType === 'other' || currentType === 'laptop' ? 'Sell to us' : 'Sell to us estimate';
      if (itemField) itemField.value = typeName;
      if (quoteIdField) quoteIdField.value = quoteId;
      if (submittedAtField) submittedAtField.value = new Date().toISOString();
      if (formSourceField) formSourceField.value = 'Website Estimator';
      if (messageField && force && !messageField.dataset.userEdited && !messageField.value) messageField.value = '';
    }

    function updateEstimate() {
      if (estimateUnlocked() && !hasUncertaintyForCurrent()) manualRequested = false;
      var automatic = estimateIsAutomatic();
      var accuracy = accuracyState();
      setPriceText();
      accuracyElements.forEach(function (element) { element.textContent = accuracy.label; });
      if (accuracyMessage) accuracyMessage.textContent = accuracy.message;
      if (estimateImprove) estimateImprove.textContent = accuracy.improve;
      if (unlockNote) {
        unlockNote.textContent = missingText();
        unlockNote.classList.toggle('is-ready', automatic || (typeMeta[currentType] && typeMeta[currentType].manual && manualSummary().length > 0));
      }
      if (inlineEstimate) inlineEstimate.classList.toggle('is-active', automatic);
      if (continueButton) {
        continueButton.disabled = !canProceedDetails();
        continueButton.textContent = automatic ? (continueButton.dataset.autoLabel || 'Show my estimate') : 'Review manual valuation';
      }
      if (manualButton) manualButton.hidden = !!(typeMeta[currentType] && typeMeta[currentType].manual);
      refreshQuestionFlow();
      renderSummary();
      buildMessage(false);
      if (currentStage === 'estimate') renderEstimateStage();
      if (currentStage === 'contact') renderContactSummary();
    }

    function parseRange(value) {
      var match = String(value || '').match(/£(\d+)[–-]£(\d+)/);
      return match ? [Number(match[1]), Number(match[2])] : null;
    }

    function animateRange(element, finalValue) {
      if (!element) return;
      var numbers = parseRange(finalValue);
      if (!numbers || prefersReducedMotion()) {
        element.textContent = finalValue;
        return;
      }
      var start = performance.now();
      var duration = 360;
      function frame(now) {
        var progress = Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - progress, 3);
        element.textContent = money(numbers[0] * eased) + '–' + money(numbers[1] * eased);
        if (progress < 1) requestAnimationFrame(frame);
        else element.textContent = finalValue;
      }
      requestAnimationFrame(frame);
    }

    function renderEstimateStage() {
      var automatic = estimateIsAutomatic();
      if (estimateAuto) estimateAuto.hidden = !automatic;
      if (estimateManual) estimateManual.hidden = automatic;
      renderRows(estimateSummary, displaySummaryRows(), 'No details have been entered yet.');
      var accuracy = accuracyState();
      accuracyElements.forEach(function (element) { element.textContent = accuracy.label; });
      if (accuracyMessage) accuracyMessage.textContent = accuracy.message;
      if (estimateImprove) estimateImprove.textContent = accuracy.improve;
      if (automatic) {
        var total = calc();
        var stage = root.querySelector('[data-stage="estimate"]');
        animateRange(stage ? stage.querySelector('[data-cash-range]') : null, range(total));
        animateRange(stage ? stage.querySelector('[data-credit-range]') : null, range(total * 1.05));
      }
    }

    function renderContactSummary() {
      var rows = [['Item type', currentType && typeMeta[currentType] ? typeMeta[currentType].title : 'Sell to us']]
        .concat(displaySummaryRows());
      if (estimateIsAutomatic()) {
        rows.push(['Cash estimate', range(calc())]);
        rows.push(['Part exchange estimate', range(calc() * 1.05)]);
      } else {
        rows.push(['Valuation', 'Manual review']);
      }
      var preference = preferredOfferValue();
      if (preference) rows.push(['Preferred option', preference]);
      if (preference === 'Part exchange' && partExchangeUrlValue()) rows.push(['DLBuilds item', partExchangeUrlValue()]);
      renderRows(contactSummary, rows, 'Your entered details will appear here.');
      buildMessage(true);
    }

    function chooseComboItem(input, item) {
      var key = input.dataset.comboInput;
      var results = input.parentNode.querySelector('[data-combo-results]');
      var recognition = root.querySelector('[data-recognition="' + key + '"]');
      selected[key] = item;
      delete uncertain[key];
      input.value = label(item);
      input.dataset.value = item.offerValue || item.suggestedOffer || 0;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      if (results) results.classList.remove('is-open');
      if (recognition) {
        recognition.textContent = 'We found it, ' + label(item) + '.';
        recognition.classList.add('is-loaded');
        recognition.classList.remove('is-manual');
      }
      updateEstimate();
    }

    function appendHighlighted(target, text, rawQuery) {
      var query = String(rawQuery || '').trim();
      if (!query) {
        target.textContent = text;
        return;
      }
      var regex;
      try { regex = new RegExp('(' + escapeRegExp(query) + ')', 'ig'); } catch (e) { target.textContent = text; return; }
      var parts = String(text).split(regex);
      parts.forEach(function (part) {
        if (part.toLowerCase() === query.toLowerCase()) {
          var mark = document.createElement('mark');
          mark.textContent = part;
          target.appendChild(mark);
        } else target.appendChild(document.createTextNode(part));
      });
    }

    function setupCombo(input) {
      var key = input.dataset.comboInput;
      var category = input.dataset.category;
      var results = input.parentNode.querySelector('[data-combo-results]');
      var recognition = root.querySelector('[data-recognition="' + key + '"]');
      var activeIndex = -1;

      function pool() { return categoryItems(category); }
      function options() { return results ? toArray(results.querySelectorAll('[role="option"]')) : []; }
      function close() {
        if (!results) return;
        results.classList.remove('is-open');
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        activeIndex = -1;
      }
      function setActive(index) {
        var opts = options();
        if (!opts.length) return;
        activeIndex = (index + opts.length) % opts.length;
        opts.forEach(function (option, optionIndex) {
          var active = optionIndex === activeIndex;
          option.classList.toggle('is-active', active);
          option.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        input.setAttribute('aria-activedescendant', opts[activeIndex].id);
        opts[activeIndex].scrollIntoView({ block: 'nearest' });
      }
      function markManual(reason) {
        delete selected[key];
        delete input.dataset.value;
        uncertain[key] = reason || 'Not listed';
        close();
        if (recognition) {
          recognition.textContent = input.value.trim() ? 'No exact match selected. Your typed information will be included for manual review.' : 'That is still helpful. We can confirm this when we review your enquiry.';
          recognition.classList.remove('is-loaded');
          recognition.classList.add('is-manual');
        }
        updateEstimate();
      }
      function render() {
        if (!results) return;
        var rawQuery = input.value.trim();
        var query = norm(rawQuery);
        if (selected[key] && norm(label(selected[key])) === query) {
          close();
          return;
        }
        if (query.length < 2) {
          close();
          return;
        }
        var tokens = query.split(' ');
        var matches = pool().map(function (item) {
          var text = label(item);
          var normal = norm(text);
          var allTokens = tokens.every(function (token) { return normal.indexOf(token) > -1; });
          if (!allTokens) return null;
          var score = query && normal.indexOf(query) === 0 ? 0 : query && normal.indexOf(query) > -1 ? 1 : 2;
          return { item: item, text: text, score: score };
        }).filter(Boolean).sort(function (a, b) {
          if (a.score !== b.score) return a.score - b.score;
          return a.text.localeCompare(b.text, undefined, { numeric: true });
        }).slice(0, 6);

        results.innerHTML = '';
        activeIndex = -1;
        if (matches.length) {
          matches.forEach(function (match, index) {
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'dlb-combo-option';
            button.id = (results.id || 'dlb-option') + '-option-' + index;
            button.setAttribute('role', 'option');
            button.setAttribute('aria-selected', 'false');
            var strong = document.createElement('strong');
            appendHighlighted(strong, match.text, rawQuery);
            button.appendChild(strong);
            button.addEventListener('click', function () { chooseComboItem(input, match.item); });
            results.appendChild(button);
          });
        } else {
          var empty = document.createElement('div');
          empty.className = 'dlb-combo-empty';
          var strongEmpty = document.createElement('strong');
          strongEmpty.textContent = priceListAvailable ? 'No exact match found.' : 'Automatic matching is unavailable.';
          var textEmpty = document.createElement('span');
          textEmpty.textContent = 'Your typed information can still be sent for manual valuation.';
          var manual = document.createElement('button');
          manual.type = 'button';
          manual.textContent = 'Continue with this information';
          manual.addEventListener('click', function () { markManual('Not listed'); });
          empty.appendChild(strongEmpty);
          empty.appendChild(textEmpty);
          empty.appendChild(manual);
          results.appendChild(empty);
        }
        results.classList.add('is-open');
        input.setAttribute('aria-expanded', 'true');
      }

      on(input, 'input', function () {
        delete selected[key];
        delete uncertain[key];
        delete input.dataset.value;
        if (recognition) {
          recognition.textContent = 'Choose an exact match, or continue with the text you entered.';
          recognition.classList.remove('is-loaded', 'is-manual');
        }
        render();
        updateEstimate();
      });
      on(input, 'focus', function () { if (input.value.trim().length >= 2 && !selected[key]) render(); });
      on(input, 'keydown', function (event) {
        var opts = options();
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          if (!results.classList.contains('is-open')) render();
          setActive(activeIndex + 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          if (!results.classList.contains('is-open')) render();
          setActive(activeIndex - 1);
        } else if (event.key === 'Enter' && activeIndex >= 0 && opts[activeIndex]) {
          event.preventDefault();
          opts[activeIndex].click();
        } else if (event.key === 'Escape') {
          event.preventDefault();
          close();
        }
      });
      input._dlbCloseCombo = close;
      input._dlbMarkManual = markManual;
    }

    function closeAllCombos(exceptTarget) {
      toArray(root.querySelectorAll('[data-combo-input]')).forEach(function (input) {
        if (exceptTarget && (input === exceptTarget || input.parentNode.contains(exceptTarget))) return;
        if (input._dlbCloseCombo) input._dlbCloseCombo();
      });
    }

    function markFieldUncertain(button) {
      var key = button.dataset.fieldKey;
      var action = button.dataset.fieldAction;
      if (!key) return;
      var input = root.querySelector('[data-combo-input="' + key + '"]');
      var select = root.querySelector('[data-standard-select="' + key + '"]');
      if (input) {
        delete selected[key];
        delete input.dataset.value;
        uncertain[key] = action === 'not-listed' ? 'Not listed' : 'Not sure';
        if (input._dlbMarkManual) input._dlbMarkManual(uncertain[key]);
      } else if (select) {
        select.selectedIndex = 0;
        uncertain[key] = action === 'not-listed' ? 'Not listed' : 'Not sure';
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      updateEstimate();
    }

    function isTransparentColour(value) {
      var colour = String(value || '').replace(/\s+/g, '').toLowerCase();
      return !colour || colour === 'transparent' || colour === 'rgba(0,0,0,0)' || /rgba\([^)]*,0(?:\.0+)?\)$/.test(colour);
    }

    function findOpaqueBackground(start) {
      var node = start;
      while (node && node.nodeType === 1) {
        var colour = window.getComputedStyle(node).backgroundColor;
        if (!isTransparentColour(colour)) return colour;
        node = node.parentElement;
      }
      return '#ffffff';
    }

    function colourIsDark(value) {
      var match = String(value || '').match(/[\d.]+/g);
      if (!match || match.length < 3) return false;
      var red = Number(match[0]);
      var green = Number(match[1]);
      var blue = Number(match[2]);
      return ((red * 299 + green * 587 + blue * 114) / 1000) < 145;
    }

    function mountHelpPortal() {
      if (!help || !document.body) return;
      var rootStyle = window.getComputedStyle(root);
      var surface = findOpaqueBackground(root);
      var darkSurface = colourIsDark(surface);
      var text = rootStyle.color;
      if (!text || isTransparentColour(text)) text = darkSurface ? '#f7f7f7' : '#121212';

      help.style.setProperty('--dlb-modal-surface', surface);
      help.style.setProperty('--dlb-bg', surface);
      help.style.setProperty('--dlb-surface', surface);
      help.style.setProperty('--dlb-text', text);
      help.style.setProperty('--dlb-muted', darkSurface ? 'rgba(255,255,255,.70)' : 'rgba(18,18,18,.66)');
      help.style.setProperty('--dlb-muted-surface', darkSurface ? 'rgba(255,255,255,.07)' : 'rgba(127,127,127,.065)');
      help.style.setProperty('--dlb-soft-surface', darkSurface ? 'rgba(255,255,255,.11)' : 'rgba(127,127,127,.10)');
      help.style.setProperty('--dlb-border', darkSurface ? 'rgba(255,255,255,.20)' : 'rgba(127,127,127,.24)');
      help.style.setProperty('--dlb-border-strong', darkSurface ? 'rgba(255,255,255,.36)' : 'rgba(127,127,127,.42)');
      help.style.setProperty('--dlb-button', darkSurface ? '#f4f4f5' : '#111827');
      help.style.setProperty('--dlb-button-text', darkSurface ? '#111827' : '#ffffff');
      help.style.setProperty('--dlb-blue', '#2563eb');
      help.style.setProperty('--dlb-violet', '#7c3aed');
      help.style.setProperty('--dlb-orange', '#d97706');
      help.style.setProperty('--dlb-cyan', '#0891b2');
      help.style.setProperty('--dlb-pink', '#db2777');
      help.style.setProperty('--dlb-success', '#087443');
      help.style.setProperty('--dlb-error', '#b42318');
      help.style.setProperty('--dlb-success-bg', darkSurface ? '#0d3324' : '#edf9f2');
      help.style.setProperty('--dlb-error-bg', darkSurface ? '#3d1717' : '#fff1f1');
      help.style.fontFamily = rootStyle.fontFamily;
      help.style.fontSize = rootStyle.fontSize;
      help.style.lineHeight = rootStyle.lineHeight;

      if (help.parentNode !== document.body) document.body.appendChild(help);
    }

    function restoreHelpHome() {
      if (!help || !helpHomeParent || !document.documentElement.contains(helpHomeParent) || help.parentNode === helpHomeParent) return;
      if (helpHomeNextSibling && helpHomeNextSibling.parentNode === helpHomeParent) helpHomeParent.insertBefore(help, helpHomeNextSibling);
      else helpHomeParent.appendChild(help);
    }

    function isHelpOpen() {
      if (!help) return false;
      return !!help.open || help.classList.contains('is-fallback-open');
    }

    function openHelp(topic) {
      if (!help || !helpPanel) return;
      var content = helpTopics[topic] || helpTopics.general;
      closeAllCombos();
      lastHelpFocus = document.activeElement;
      if (helpTitle) helpTitle.textContent = content.title;
      if (helpCopy) helpCopy.textContent = content.copy;
      if (helpExamples) {
        helpExamples.innerHTML = '';
        (content.examples || []).forEach(function (example) {
          var span = document.createElement('span');
          span.textContent = example;
          helpExamples.appendChild(span);
        });
      }
      if (helpGeneral) helpGeneral.hidden = !content.general;
      if (helpSpecific) helpSpecific.hidden = !!content.general;
      if (helpSteps) {
        helpSteps.innerHTML = '';
        (content.steps || []).forEach(function (step, index) {
          var li = document.createElement('li');
          var number = document.createElement('span');
          var text = document.createElement('p');
          number.textContent = String(index + 1);
          text.textContent = step;
          li.appendChild(number);
          li.appendChild(text);
          helpSteps.appendChild(li);
        });
      }
      if (helpCards) {
        helpCards.innerHTML = '';
        (content.cards || []).forEach(function (card) {
          var div = document.createElement('div');
          var strong = document.createElement('strong');
          var paragraph = document.createElement('p');
          strong.textContent = card.title;
          paragraph.textContent = card.text;
          div.appendChild(strong);
          div.appendChild(paragraph);
          helpCards.appendChild(div);
        });
      }

      mountHelpPortal();
      root.classList.add('is-help-open');
      previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      if (typeof help.showModal === 'function') {
        if (!help.open) {
          try { help.showModal(); }
          catch (error) {
            help.setAttribute('open', '');
            help.classList.add('is-fallback-open');
          }
        }
      } else {
        help.setAttribute('open', '');
        help.classList.add('is-fallback-open');
      }

      try { helpPanel.focus({ preventScroll: true }); } catch (e) { helpPanel.focus(); }
    }

    function closeHelp() {
      if (!help) return;
      var wasOpen = isHelpOpen();
      if (help.open && typeof help.close === 'function') {
        try { help.close(); } catch (e) { help.removeAttribute('open'); }
      } else {
        help.removeAttribute('open');
      }
      help.classList.remove('is-fallback-open');
      root.classList.remove('is-help-open');
      document.body.style.overflow = previousBodyOverflow;
      restoreHelpHome();
      if (wasOpen && lastHelpFocus && document.contains(lastHelpFocus)) {
        try { lastHelpFocus.focus({ preventScroll: true }); } catch (e) { lastHelpFocus.focus(); }
      }
    }

    function trapHelpFocus(event) {
      if (!isHelpOpen()) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeHelp();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusables = toArray(helpPanel.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function preferredOfferValue() {
      var checked = offerOptionInputs.find(function (input) { return input.checked; });
      return checked ? checked.value : '';
    }

    function partExchangeUrlValue() {
      return partExchangeUrl ? partExchangeUrl.value.trim() : '';
    }

    function isValidDlbuildsUrl(value) {
      if (!value) return false;
      try {
        var parsed = new URL(value);
        var host = String(parsed.hostname || '').toLowerCase().replace(/^www\./, '');
        return (parsed.protocol === 'http:' || parsed.protocol === 'https:') && (host === 'dlbuilds.co.uk' || host.endsWith('.dlbuilds.co.uk'));
      } catch (error) {
        return false;
      }
    }

    function offerPreferenceLines() {
      var preference = preferredOfferValue();
      if (!preference) return [];
      var lines = ['Preferred offer: ' + preference];
      if (preference === 'Part exchange' && partExchangeUrlValue()) lines.push('Part exchange product URL: ' + partExchangeUrlValue());
      return lines;
    }

    function updateOfferChoice() {
      var preference = preferredOfferValue();
      if (offerChoice) offerChoice.dataset.selectedOffer = preference;
      offerOptionInputs.forEach(function (input) {
        var option = input.closest('.dlb-offer-option');
        if (option) option.classList.toggle('is-selected', input.checked);
      });
      if (partExchangeField) partExchangeField.hidden = preference !== 'Part exchange';
      if (preference !== 'Part exchange') {
        if (partExchangeUrl) partExchangeUrl.removeAttribute('aria-invalid');
        if (partExchangeError) { partExchangeError.hidden = true; partExchangeError.textContent = ''; }
      }
      if (offerChoiceError && preference) { offerChoiceError.hidden = true; offerChoiceError.textContent = ''; }
      if (currentStage === 'contact') renderContactSummary();
    }

    function selectedValueByLabel(labelName) {
      var rows = selectedSummary();
      var found = rows.find(function (row) { return String(row[0] || '').toLowerCase() === String(labelName || '').toLowerCase(); });
      return found ? found[1] : '';
    }

    function setTurnstileError(message) {
      if (!turnstileError) return;
      turnstileError.textContent = message || '';
      turnstileError.hidden = !message;
    }

    function currentTurnstileToken() {
      if (turnstileToken) return turnstileToken;
      if (turnstileWidgetId !== null && window.turnstile && typeof window.turnstile.getResponse === 'function') {
        try { return window.turnstile.getResponse(turnstileWidgetId) || ''; } catch (e) {}
      }
      var hidden = root.querySelector('[name="cf-turnstile-response"]');
      return hidden ? String(hidden.value || '') : '';
    }

    function resetTurnstile() {
      turnstileToken = '';
      if (turnstileWidgetId !== null && window.turnstile && typeof window.turnstile.reset === 'function') {
        try { window.turnstile.reset(turnstileWidgetId); } catch (e) {}
      }
    }

    function setupTurnstile() {
      if (!turnstileSiteKey || !turnstileContainer) return;

      var attempts = 0;
      function renderWhenReady() {
        if (window.turnstile && typeof window.turnstile.render === 'function') {
          try {
            turnstileWidgetId = window.turnstile.render(turnstileContainer, {
              sitekey: turnstileSiteKey,
              theme: 'auto',
              size: 'flexible',
              appearance: 'interaction-only',
              action: 'sell_to_us_submit',
              callback: function (token) {
                turnstileToken = String(token || '');
                setTurnstileError('');
              },
              'expired-callback': function () {
                turnstileToken = '';
              },
              'error-callback': function () {
                turnstileToken = '';
                setTurnstileError('Security verification could not load. Please refresh the page and try again.');
              }
            });
          } catch (e) {
            setTurnstileError('Security verification could not load. Please refresh the page and try again.');
          }
          return;
        }

        attempts += 1;
        if (attempts < 50) {
          setTimeout(renderWhenReady, 100);
        } else {
          setTurnstileError('Security verification could not load. Please refresh the page and try again.');
        }
      }

      renderWhenReady();
    }

    /* Payload keys intentionally map to the Sell to Us Worker API. */
    function quotePayload() {
      var total = calc();
      var automatic = estimateIsAutomatic();
      var typeName = currentType ? typeMeta[currentType].title : 'Sell to us';
      var summaryText = estimateSummaryField ? estimateSummaryField.value : '';
      var form = root.querySelector('[data-dlb-contact-form]') || root.querySelector('form[action]');
      var formData = form ? new FormData(form) : new FormData();
      var name = formData.get('customerName') || formData.get('contact[Name]') || formData.get('contact[name]') || '';
      var email = formData.get('email') || formData.get('contact[email]') || formData.get('contact[Email]') || '';
      var phone = formData.get('phone') || formData.get('contact[phone]') || formData.get('contact[Phone]') || '';
      var photoUrl = formData.get('photoUrl') || formData.get('contact[photo-url-1]') || '';
      var customerNotes = messageField ? messageField.value.trim() : '';
      var generatedDetails = buildGeneratedDetailsText();
      var combinedNotes = customerNotes;
      if (generatedDetails) combinedNotes += (combinedNotes ? '\n\n' : '') + 'Details entered for manual review:\n' + generatedDetails;
      var offerLines = offerPreferenceLines();
      if (offerLines.length) combinedNotes += (combinedNotes ? '\n\n' : '') + 'Offer preference:\n' + offerLines.join('\n');
      return {
        source: 'Website Estimator Direct',
        quoteId: quoteId,
        submittedAt: new Date().toISOString(),
        customerName: String(name || ''),
        email: String(email || ''),
        phone: String(phone || ''),
        itemType: typeName,
        cpu: selectedValueByLabel('CPU'),
        gpu: selectedValueByLabel('GPU'),
        ram: selectedValueByLabel('RAM'),
        storage: selectedValueByLabel('Storage'),
        mainStorage: selectedValueByLabel('Main storage'),
        extraStorage: selectedValueByLabel('Extra storage'),
        motherboard: selectedValueByLabel('Motherboard'),
        condition: currentSelectText('[data-condition="' + currentType + '"]'),
        faults: currentSelectText('[data-faults="' + currentType + '"]'),
        cashEstimate: automatic ? range(total) : 'Manual valuation needed',
        storeCreditEstimate: automatic ? range(total * 1.05) : 'Manual valuation needed',
        estimateSummary: summaryText,
        preferredOffer: preferredOfferValue(),
        partExchangeUrl: partExchangeUrlValue(),
        notes: combinedNotes,
        photoUrl: String(photoUrl || ''),
        turnstileToken: currentTurnstileToken()
      };
    }

    function backupBodyFromPayload(payload) {
      var lines = [
        'Sell to us estimate request',
        '',
        'Backup website form submission',
        'Quote ID: ' + (payload.quoteId || ''),
        'Submitted: ' + (payload.submittedAt || ''),
        '',
        'Customer',
        'Name: ' + (payload.customerName || ''),
        'Email: ' + (payload.email || ''),
        'Phone: ' + (payload.phone || ''),
        '',
        'Item',
        'Type: ' + (payload.itemType || ''),
        'CPU: ' + (payload.cpu || ''),
        'GPU: ' + (payload.gpu || ''),
        'RAM: ' + (payload.ram || ''),
        'Main storage: ' + (payload.mainStorage || payload.storage || ''),
        'Extra storage: ' + (payload.extraStorage || ''),
        'Motherboard: ' + (payload.motherboard || ''),
        'Condition: ' + (payload.condition || ''),
        'Faults/issues: ' + (payload.faults || ''),
        '',
        'Estimate shown',
        'Cash: ' + (payload.cashEstimate || ''),
        'Part exchange: ' + (payload.storeCreditEstimate || ''),
        'Preferred option: ' + (payload.preferredOffer || ''),
        'Part exchange product: ' + (payload.partExchangeUrl || ''),
        '',
        'Estimate summary',
        payload.estimateSummary || '',
        '',
        'Photo link: ' + (payload.photoUrl || ''),
        '',
        'Customer notes',
        payload.notes || ''
      ];
      return lines.join('\n');
    }

    function syncBackupForm() {
      var backupForm = backupWrap ? backupWrap.querySelector('form') : null;
      if (!backupForm) return;
      buildMessage(true);
      var payload = quotePayload();
      toArray(backupForm.querySelectorAll('[data-backup-field]')).forEach(function (input) {
        var key = input.dataset.backupField;
        input.value = payload[key] || '';
      });
      var requestTypeHidden = backupForm.querySelector('[data-backup-field="requestType"]');
      if (requestTypeHidden) requestTypeHidden.value = requestType ? requestType.value : 'Sell to us estimate';
      var body = backupForm.querySelector('[data-backup-body]');
      if (body) body.value = backupBodyFromPayload(payload);
    }

    function showBackupForm() {
      if (!backupWrap) return;
      syncBackupForm();
      backupWrap.hidden = false;
      try { backupWrap.scrollIntoView({ behavior: smoothBehaviour(), block: 'center' }); } catch (e) {}
    }

    function wait(ms) { return new Promise(function (resolve) { setTimeout(resolve, ms); }); }

    function fetchWithTimeout(url, options, timeoutMs) {
      timeoutMs = timeoutMs || 12000;
      if (typeof AbortController === 'undefined') return fetch(url, options);
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, timeoutMs);
      options = options || {};
      options.signal = controller.signal;
      return fetch(url, options).finally(function () { clearTimeout(timer); });
    }

    function submitDirectQuote(onAttempt) {
      if (!quoteEndpoint) return Promise.reject(new Error('No quote endpoint'));
      var payload = quotePayload();
      var body = JSON.stringify(payload);
      // Turnstile tokens are single-use. With Turnstile enabled we make one server attempt,
      // then reset the widget and let the customer retry with a fresh token if needed.
      var delays = turnstileSiteKey ? [0] : [0, 900, 2200, 4200];
      var lastError = null;

      function attempt(index) {
        if (onAttempt) onAttempt(index + 1, delays.length);
        return fetchWithTimeout(quoteEndpoint, {
          method: 'POST',
          mode: 'cors',
          cache: 'no-store',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: body
        }, index === 0 ? 12000 : 16000).then(function (response) {
          if (response.status === 409 || response.status === 208) return { duplicateAccepted: true };
          if (!response.ok) {
            return response.text().then(function (text) {
              var message = text || ('HTTP ' + response.status);
              try {
                var parsed = JSON.parse(text);
                if (parsed && parsed.error) message = parsed.error;
              } catch (e) {}
              if (/duplicate|already exists|already received/i.test(message)) return { duplicateAccepted: true };
              throw new Error(message);
            });
          }
          return response.json().catch(function () { return {}; });
        }).catch(function (error) {
          lastError = error;
          if (index < delays.length - 1) return wait(delays[index + 1]).then(function () { return attempt(index + 1); });
          throw lastError || new Error('Direct quote receiver failed');
        });
      }

      return attempt(0);
    }

    function productEndpoint() {
      var handle = String(productCollectionHandle || 'all').trim();
      if (!handle || handle === 'all') return '/products.json?limit=50';
      return '/collections/' + encodeURIComponent(handle) + '/products.json?limit=50';
    }

    function formatProductPrice(product) {
      var variants = product && product.variants ? product.variants : [];
      if (!variants.length || variants[0].price == null) return '';
      var price = Number(variants[0].price);
      if (!isFinite(price) || price <= 0) return '';
      return '£' + price.toFixed(price % 1 ? 2 : 0);
    }

    function renderPostSubmitProducts(products) {
      if (!postSubmitProducts || !postSubmitProductGrid || !products || !products.length) return;
      var pool = products.filter(function (product) { return product && product.handle && product.title; });
      if (!pool.length) return;
      pool.sort(function () { return Math.random() - 0.5; });
      postSubmitProductGrid.innerHTML = '';
      pool.slice(0, 4).forEach(function (product) {
        var card = document.createElement('a');
        card.className = 'dlb-product-card';
        card.href = '/products/' + product.handle;
        card.target = '_self';
        var image = product.images && product.images[0] && product.images[0].src ? product.images[0].src : '';
        var price = formatProductPrice(product);
        if (image) {
          var img = document.createElement('img');
          img.src = image;
          img.alt = product.title;
          img.loading = 'lazy';
          card.appendChild(img);
        }
        var cardBody = document.createElement('span');
        cardBody.className = 'dlb-product-card__body';
        var title = document.createElement('strong');
        title.textContent = product.title;
        cardBody.appendChild(title);
        if (price) {
          var priceElement = document.createElement('em');
          priceElement.textContent = 'From ' + price;
          cardBody.appendChild(priceElement);
        }
        card.appendChild(cardBody);
        postSubmitProductGrid.appendChild(card);
      });
      postSubmitProducts.hidden = false;
    }

    function loadPostSubmitProducts() {
      if (!postSubmitProducts || !postSubmitProductGrid || postSubmitProducts.dataset.loaded === 'true') return;
      postSubmitProducts.dataset.loaded = 'true';
      fetch(productEndpoint(), { credentials: 'same-origin' })
        .then(function (response) { if (!response.ok) throw new Error('Products unavailable'); return response.json(); })
        .then(function (json) { renderPostSubmitProducts(json.products || []); })
        .catch(function () { postSubmitProducts.hidden = true; });
    }

    function clearContactErrors(form) {
      toArray(form.querySelectorAll('[aria-invalid="true"]')).forEach(function (element) { element.removeAttribute('aria-invalid'); });
      toArray(form.querySelectorAll('[data-field-error], [data-consent-error], [data-offer-choice-error], [data-part-exchange-error]')).forEach(function (error) { error.hidden = true; error.textContent = ''; });
      if (offerChoice) offerChoice.classList.remove('is-invalid');
      var consentWrap = form.querySelector('[data-consent-wrap]');
      if (consentWrap) consentWrap.classList.remove('is-invalid');
      var validationSummary = form.querySelector('[data-validation-summary]');
      if (validationSummary) validationSummary.hidden = true;
      if (currentTurnstileToken()) setTurnstileError('');
    }

    function setFieldError(input, message) {
      input.setAttribute('aria-invalid', 'true');
      var field = input.closest('.dlb-field');
      var error = field ? field.querySelector('[data-field-error]') : null;
      if (error) { error.textContent = message; error.hidden = false; }
    }

    function validateContactForm(form) {
      clearContactErrors(form);
      var errors = [];
      var name = form.querySelector('[name="customerName"]');
      var email = form.querySelector('[name="email"]');
      var consent = form.querySelector('[name="estimateDisclaimerAccepted"]');
      var preference = preferredOfferValue();
      if (!preference) {
        if (offerChoice) offerChoice.classList.add('is-invalid');
        if (offerChoiceError) { offerChoiceError.textContent = 'Choose cash or part exchange.'; offerChoiceError.hidden = false; }
        if (offerOptionInputs[0]) offerOptionInputs[0].setAttribute('aria-invalid', 'true');
        errors.push('Choose cash or part exchange.');
      } else if (preference === 'Part exchange') {
        var exchangeUrl = partExchangeUrlValue();
        if (!exchangeUrl) {
          if (partExchangeUrl) partExchangeUrl.setAttribute('aria-invalid', 'true');
          if (partExchangeError) { partExchangeError.textContent = 'Paste the DLBuilds product URL you are interested in.'; partExchangeError.hidden = false; }
          errors.push('Add the DLBuilds product URL.');
        } else if (!isValidDlbuildsUrl(exchangeUrl)) {
          if (partExchangeUrl) partExchangeUrl.setAttribute('aria-invalid', 'true');
          if (partExchangeError) { partExchangeError.textContent = 'Has to be an item we have available.'; partExchangeError.hidden = false; }
          errors.push('The part exchange link has to be an item we have available.');
        }
      }
      if (!name || !name.value.trim()) {
        if (name) setFieldError(name, 'Enter your name.');
        errors.push('Enter your name.');
      }
      if (!email || !email.value.trim()) {
        if (email) setFieldError(email, 'Enter your email address.');
        errors.push('Enter your email address.');
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
        setFieldError(email, 'Enter a valid email address.');
        errors.push('Enter a valid email address.');
      }
      if (!consent || !consent.checked) {
        var consentWrap = form.querySelector('[data-consent-wrap]');
        var consentError = form.querySelector('[data-consent-error]');
        if (consentWrap) consentWrap.classList.add('is-invalid');
        if (consent) consent.setAttribute('aria-invalid', 'true');
        if (consentError) { consentError.textContent = 'Please accept the estimate disclaimer before submitting.'; consentError.hidden = false; }
        errors.push('Accept the estimate disclaimer.');
      }
      if (turnstileSiteKey && !currentTurnstileToken()) {
        setTurnstileError('Please complete the security check before sending.');
        errors.push('Complete the security check.');
      }
      if (errors.length) {
        var summaryBox = form.querySelector('[data-validation-summary]');
        var summaryText = form.querySelector('[data-validation-summary-text]');
        if (summaryText) summaryText.textContent = errors.join(' ');
        if (summaryBox) summaryBox.hidden = false;
        var firstInvalid = form.querySelector('[aria-invalid="true"]');
        if (firstInvalid) firstInvalid.focus();
        return false;
      }
      return true;
    }

    function setupAjaxContactForm() {
      var form = root.querySelector('[data-dlb-contact-form]');
      if (!form) return;
      var success = root.querySelector('[data-ajax-success]');
      var error = root.querySelector('[data-ajax-error]');
      var submit = form.querySelector('button[type="submit"]');

      toArray(form.querySelectorAll('input, textarea')).forEach(function (input) {
        on(input, 'input', function () {
          input.removeAttribute('aria-invalid');
          var field = input.closest('.dlb-field');
          var fieldError = field ? field.querySelector('[data-field-error]') : null;
          if (fieldError) fieldError.hidden = true;
          if (input.hasAttribute('data-part-exchange-url')) {
            if (partExchangeError) partExchangeError.hidden = true;
            if (currentStage === 'contact') renderContactSummary();
          }
        });
        on(input, 'change', function () {
          if (input.hasAttribute('data-offer-option')) {
            offerOptionInputs.forEach(function (option) { option.removeAttribute('aria-invalid'); });
            if (offerChoice) offerChoice.classList.remove('is-invalid');
            updateOfferChoice();
          }
          if (input.hasAttribute('data-part-exchange-url')) {
            input.removeAttribute('aria-invalid');
            if (partExchangeError) partExchangeError.hidden = true;
            if (currentStage === 'contact') renderContactSummary();
          }
          if (input.name === 'estimateDisclaimerAccepted') {
            var wrap = form.querySelector('[data-consent-wrap]');
            var consentError = form.querySelector('[data-consent-error]');
            if (wrap) wrap.classList.remove('is-invalid');
            input.removeAttribute('aria-invalid');
            if (consentError) consentError.hidden = true;
          }
        });
      });

      on(form, 'submit', function (event) {
        event.preventDefault();
        if (isSubmittingQuote) return;
        buildMessage(true);
        if (!validateContactForm(form)) return;
        isSubmittingQuote = true;
        if (success) success.hidden = true;
        if (error) {
          error.hidden = true;
          if (errorText) errorText.textContent = 'Sorry, we could not send this automatically. Your details have been kept.';
          if (showBackupButton) showBackupButton.hidden = true;
        }
        if (backupWrap) backupWrap.hidden = true;
        var originalText = submit ? submit.textContent : '';
        if (submit) { submit.disabled = true; submit.textContent = 'Sending…'; }

        submitDirectQuote(function (attempt, total) {
          if (submit) submit.textContent = attempt > 1 ? ('Retrying ' + attempt + '/' + total + '…') : 'Sending…';
        }).then(function () {
          isSubmittingQuote = false;
          form.classList.add('is-sent');
          root.classList.add('is-contact-sent');
          try { if (window.sessionStorage) sessionStorage.removeItem(quoteIdStorageKey); } catch (e) {}
          if (success) {
            success.hidden = false;
            success.focus();
            try { success.scrollIntoView({ behavior: smoothBehaviour(), block: 'center' }); } catch (e) {}
          }
          loadPostSubmitProducts();
          if (submit) { submit.disabled = true; submit.textContent = 'Sent'; }
        }).catch(function (submitError) {
          isSubmittingQuote = false;
          resetTurnstile();
          if (window.console && console.warn) console.warn('DLBuilds quote submit failed:', submitError);
          if (error) {
            if (errorText) errorText.textContent = submitError && submitError.message ? submitError.message + ' Your information is still here, so you can retry or use the backup website form.' : 'We could not send this automatically. Your information is still here, so you can retry or use the backup website form.';
            if (showBackupButton) showBackupButton.hidden = false;
            error.hidden = false;
            try { error.scrollIntoView({ behavior: smoothBehaviour(), block: 'nearest' }); } catch (e) {}
          }
          syncBackupForm();
          if (submit) { submit.disabled = false; submit.textContent = originalText || 'Send'; }
        });
      });
    }

    typeButtons.forEach(function (button) { on(button, 'click', function () { setType(button.dataset.type); }); });
    toArray(root.querySelectorAll('[data-knowledge]')).forEach(function (button) { on(button, 'click', function () { setKnowledge(button.dataset.knowledge); }); });
    toArray(root.querySelectorAll('[data-open-help]')).forEach(function (button) { on(button, 'click', function () { openHelp(button.dataset.openHelp || 'general'); }); });
    toArray(root.querySelectorAll('[data-close-spec-help]')).forEach(function (button) { on(button, 'click', closeHelp); });
    on(help, 'cancel', function (event) { event.preventDefault(); closeHelp(); });
    on(help, 'click', function (event) { if (event.target === help) closeHelp(); });
    toArray(root.querySelectorAll('[data-field-action]')).forEach(function (button) { on(button, 'click', function () { markFieldUncertain(button); }); });
    toArray(root.querySelectorAll('[data-visual-select]')).forEach(setupVisualSelect);
    toArray(root.querySelectorAll('[data-combo-input]')).forEach(setupCombo);

    on(document, 'click', function (event) { closeAllCombos(event.target); });
    on(document, 'keydown', trapHelpFocus);

    var backToChoose = root.querySelector('[data-back-to-choose]');
    on(backToChoose, 'click', function () { showStage('choose', { scroll: true }); });

    var confirmTypeChange = root.querySelector('[data-confirm-type-change]');
    on(confirmTypeChange, 'click', function () {
      var nextType = pendingType;
      clearType(currentType);
      applyType(nextType || 'other');
    });
    var cancelTypeChange = root.querySelector('[data-cancel-type-change]');
    on(cancelTypeChange, 'click', function () {
      pendingType = null;
      if (typeConfirm) typeConfirm.hidden = true;
      updateTypeButtons();
    });

    var changeKnowledge = root.querySelector('[data-change-knowledge]');
    on(changeKnowledge, 'click', function () {
      if (!currentType) return;
      delete knowledgeModes[currentType];
      updateKnowledgeView();
      if (knowledgeStep) knowledgeStep.scrollIntoView({ behavior: smoothBehaviour(), block: 'start' });
    });

    on(continueButton, 'click', function () {
      if (!canProceedDetails()) return;
      manualRequested = !estimateUnlocked() || !!typeMeta[currentType].manual;
      buildMessage(true);
      showStage('estimate', { scroll: true });
    });

    on(manualButton, 'click', function () {
      if (!hasMeaningfulDetails()) {
        if (unlockNote) {
          unlockNote.textContent = 'Enter anything you know first, even a partial model such as “Ryzen 5” or “RTX 30 series”.';
          unlockNote.classList.remove('is-ready');
        }
        var firstInput = activeFieldSet() ? activeFieldSet().querySelector('input, select, textarea') : null;
        if (firstInput) firstInput.focus();
        return;
      }
      manualRequested = true;
      buildMessage(true);
      showStage('estimate', { scroll: true });
    });

    toArray(root.querySelectorAll('[data-edit-details]')).forEach(function (button) {
      on(button, 'click', function () {
        if (root.classList.contains('is-contact-sent')) return;
        showStage('build', { scroll: true });
      });
    });

    var estimateContinue = root.querySelector('[data-estimate-continue]');
    on(estimateContinue, 'click', function () {
      buildMessage(true);
      showStage('contact', { scroll: true });
    });

    var backToBuild = root.querySelector('[data-back-to-build]');
    on(backToBuild, 'click', function () {
      if (root.classList.contains('is-contact-sent')) return;
      showStage('estimate', { scroll: true });
    });

    toArray(root.querySelectorAll('[data-standard-select], [data-condition], [data-faults]')).forEach(function (element) {
      on(element, 'change', function () {
        if (element.dataset.standardSelect && element.selectedIndex > 0) delete uncertain[element.dataset.standardSelect];
        var groupContainer = element.closest('.dlb-question-card, .dlb-field');
        var group = groupContainer ? groupContainer.querySelector('[data-visual-select]') : null;
        if (group) setVisualSelectState(group);
        updateEstimate();
      });
    });

    toArray(root.querySelectorAll('[data-manual-input]')).forEach(function (input) { on(input, 'input', updateEstimate); });
    updateOfferChoice();
    if (messageField) on(messageField, 'input', function () { messageField.dataset.userEdited = 'true'; });
    if (showBackupButton) on(showBackupButton, 'click', showBackupForm);
    if (backupWrap) {
      var backupForm = backupWrap.querySelector('form');
      if (backupForm) on(backupForm, 'submit', syncBackupForm);
    }

    var summaryToggle = root.querySelector('[data-summary-toggle]');
    on(summaryToggle, 'click', function () {
      if (!floating) return;
      var expanded = !floating.classList.contains('is-expanded');
      floating.classList.toggle('is-expanded', expanded);
      summaryToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });

    setupTurnstile();
    setupAjaxContactForm();
    showStage('choose', { noFocus: true });
    updateEstimate();

    if (dataUrl) {
      fetch(dataUrl, { credentials: 'same-origin', cache: 'no-store' })
        .then(function (response) { if (!response.ok) throw new Error('Price list unavailable'); return response.json(); })
        .then(function (json) {
          items = json.items || [];
          priceListAvailable = items.length > 0;
          populateRamSelects();
          populateStorageSelects();
          if (priceStatus) priceStatus.hidden = priceListAvailable;
          updateEstimate();
        })
        .catch(function () {
          items = [];
          priceListAvailable = false;
          if (priceStatus) priceStatus.hidden = false;
          updateEstimate();
        });
    } else {
      priceListAvailable = false;
      if (priceStatus) priceStatus.hidden = false;
    }

    root._dlbSellEstimatorCleanup = function () {
      closeHelp();
      restoreHelpHome();
      cleanupCallbacks.forEach(function (cleanup) {
        try { cleanup(); } catch (e) {}
      });
      cleanupCallbacks = [];
      delete root._dlbSellEstimatorCleanup;
      delete root.dataset.dlbEstimatorInitialized;
    };
  }

  function initAll(scope) {
    var target = scope || document;
    if (target.matches && target.matches('[data-dlb-sell-estimator]')) init(target);
    toArray(target.querySelectorAll ? target.querySelectorAll('[data-dlb-sell-estimator]') : []).forEach(init);
  }

  function boot() { initAll(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var roots = [];
    if (event.target && event.target.matches && event.target.matches('[data-dlb-sell-estimator]')) roots.push(event.target);
    if (event.target && event.target.querySelectorAll) roots = roots.concat(toArray(event.target.querySelectorAll('[data-dlb-sell-estimator]')));
    roots.forEach(function (root) { if (root._dlbSellEstimatorCleanup) root._dlbSellEstimatorCleanup(); });
  });
})();
